<script setup>
import { ref, onMounted, toRefs, computed } from 'vue'
import { useMaterialReportStore } from '@/src/stores/materialReport.store'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import BaseDatePicker from '@/src/vueComponent/BaseDatePicker.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import dayjs from 'dayjs'

const props = defineProps({
  supplierCategoryList: {
    type: Array,
    default: () => []
  }
})
const { supplierCategoryList } = toRefs(props)

const searchInfo = ref({
  lot_no: '',
  supplier: '',
  category: '',
  start_date: '',
  end_date: ''
})

const searchInfoAllEmpty = computed(() => {
  return Object.values(searchInfo.value).every((value) => value === null || value === '')
})

const categoryList = supplierCategoryList.value.map(([label, value]) => ({
  value,
  label
}))

const materialReportStore = useMaterialReportStore()
const showtip = ref(null)
onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.lot_no = searchParams.get('lot_no')
  searchInfo.value.supplier = searchParams.get('supplier')
  searchInfo.value.category = searchParams.get('category')
  searchInfo.value.start_date = searchParams.get('start_date')
  searchInfo.value.end_date = searchParams.get('end_date')

  showtip.value = searchInfoAllEmpty.value
  materialReportStore.updateShowTip(showtip.value)
  if (searchInfo.value.category === null) {
    searchInfo.value.category = 'coating'
  }
})

const checkDateOnlyOneChosen = () => {
  return (
    (searchInfo.value.start_date && !searchInfo.value.end_date) ||
    (!searchInfo.value.start_date && searchInfo.value.end_date)
  )
}

const checkDateConverse = () => {
  return dayjs(searchInfo.value.start_date).isAfter(dayjs(searchInfo.value.end_date))
}

const checkRangeOverTwoMonths = () => {
  const monthDifference = dayjs(searchInfo.value.end_date).diff(
    dayjs(searchInfo.value.start_date),
    'month'
  )

  return monthDifference >= 2
}

const handleSubmit = (event) => {
  if (checkDateOnlyOneChosen()) {
    mySwal.error({
      title: '請選擇一個日期區間'
    })
    event.preventDefault()
  } else if (checkDateConverse()) {
    mySwal.error({
      title: '起始日期不得晚於結束日期'
    })
    event.preventDefault()
  } else if (checkRangeOverTwoMonths()) {
    mySwal.error({
      title: '日期範圍不得超過 2 個月'
    })
    event.preventDefault()
  } else {
    event.target.submit()
  }
}
</script>

<template>
  <form
    class="min-w-[248px] p-4"
    action="/material_reports"
    accept-charset="UTF-8"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <div class="mb-2">
      <BaseTextInput :label="'批號'" :name="'lot_no'" v-model="searchInfo.lot_no"></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseTextInput
        :label="'供應商'"
        :name="'supplier'"
        v-model="searchInfo.supplier"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'供應商分類'"
        :name="'category'"
        :optionList="categoryList"
        :optionsSelected="searchInfo.category"
        @select="searchInfo.category = $event"
      />
    </div>
    <div class="mb-2">
      <BaseDatePicker :label="'日期（起）'" :name="'start_date'" v-model="searchInfo.start_date" />
    </div>
    <div class="mb-2">
      <BaseDatePicker :label="'日期（迄）'" :name="'end_date'" v-model="searchInfo.end_date" />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a href="/material_reports" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
<style scoped>
.anticon {
  display: inline-flex;
}
</style>
